import {
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextareaAutosize,
  TextField,
  Typography,
} from "@material-ui/core";
import { EditOutlined } from "@material-ui/icons";
import { getDatabase, ref, update } from "firebase/database";
import React from "react";
import { BeatLoader } from "react-spinners";

const Addjob = () => {
  const [jobFor, setJobFor] = React.useState(1);
  const [title, setTitle] = React.useState("");
  const [location, setLocation] = React.useState("");
  const [salary, setSalary] = React.useState("");
  const [skill, setSkill] = React.useState("");
  const [delayTime, setDelayTime] = React.useState("");
  const [jobPrice, setJobPrice] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");

  const saveNewJob = () => {
    if (
      jobFor &&
      title &&
      location &&
      salary &&
      skill &&
      delayTime &&
      jobPrice &&
      description
    ) {
      setLoading(true);
      const currentDate = new Date();
      const jobId = currentDate.getTime();

      const job = {
        jobId,
        jobFor,
        title,
        location,
        salary,
        skill,
        delayTime,
        jobPrice,
        description,
      };
      const db = getDatabase();

      update(ref(db, `Jobs/${jobId}`), job)
        .then((res) => {
          setLoading(false);
          //   setJobFor("");
          //   setDescription("");
          //   setJobPrice("");
          //   setTitle("");
          //   setLocation("");
          //   setSalary("");
          //   setSkill("");
          //   setError("");
        })
        .catch((err) => {
          setLoading(false);

          setError("Job Add Failed.");
        });
    } else {
      setLoading(false);
      setError("Enter All Input Data");
    }
  };

  return (
    <div>
      <Grid container spacing={5}>
        <Grid item xs={10} sm={10} md={6}>
          <FormControl fullWidth>
            <Typography variant="h6">Jobs For</Typography>
            <br />
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={jobFor}
              onChange={(e) => setJobFor(e.target.value)}
              label="Jobs For"
            >
              <MenuItem value={1}>Home Page</MenuItem>
              <MenuItem value={2}>For You Page</MenuItem>
              <MenuItem value={3}>New Job Page</MenuItem>
              <MenuItem value={4}>Trending Job Page</MenuItem>
            </Select>

            <br />
            <br />
            <TextField
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              label="Title"
              variant="outlined"
              color="secondary"
              required
              type="text"
            />
            <br />
            <br />
            <TextField
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              label="Location"
              variant="outlined"
              color="secondary"
              required
              type="text"
            />
            <br />
            <br />
            <TextField
              value={salary}
              onChange={(e) => setSalary(parseFloat(e.target.value))}
              label="Salary"
              variant="outlined"
              color="secondary"
              required
              type="number"
            />
            <br />
            <br />
            <TextField
              value={skill}
              onChange={(e) => setSkill(e.target.value)}
              label="Skill"
              variant="outlined"
              color="secondary"
              required
              type="text"
            />
            <br />
            <br />
            <TextField
              value={delayTime}
              onChange={(e) => setDelayTime(parseFloat(e.target.value))}
              label="Delay Time(Min)"
              variant="outlined"
              color="secondary"
              required
              type="number"
            />
            <br />
            <br />
            <TextField
              value={jobPrice}
              onChange={(e) => setJobPrice(parseFloat(e.target.value))}
              label="Job Price"
              variant="outlined"
              color="secondary"
              required
              type="number"
            />
            <br />
            <br />
            <TextareaAutosize
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              label="Job Description"
              variant="outlined"
              color="secondary"
              required
              type="number"
              minRows={4}
              style={{ width: "100%" }}
            />
            <br />
            <br />
            <p style={{ color: "red" }}>{error}</p>
            <br />
            <br />
            {loading ? (
              <BeatLoader loading={loading} />
            ) : (
              <Button
                disabled={loading}
                onClick={() => saveNewJob()}
                style={{ marginBottom: "10px" }}
                color="secondary"
                variant="outlined"
                type="submit"
                endIcon={<EditOutlined />}
              >
                Save
              </Button>
            )}
          </FormControl>
        </Grid>
      </Grid>
    </div>
  );
};

export default Addjob;
